import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import AbstractChart from "surveylabJsAssets/chart/plugin/abstract-chart";

export class JobInfoPie extends AbstractChart {
    protected allChartOptions(): Options {
        return super.mergeOptions(
            super.allChartOptions(), {
                chart: {
                    type: 'pie',

                },
                tooltip: {
                    enabled: true,
                    formatter: function () {
                        return this.percentage.toFixed(1) + "%";
                    }
                },
                plotOptions: {
                    pie: {
                        borderWidth: 3,
                        dataLabels: {
                            format: '{point.percentage:.2f}%',
                            distance: 10
                        },
                        states: {
                            hover: {
                                halo: {
                                    attributes: {
                                        fill: '#444'
                                    }
                                }
                            },
                            inactive: {
                                enabled: false,
                            }
                        }
                    },
                    series: {
                        point: {
                            events: {
                                legendItemClick: (e) => {
                                    return false;
                                },
                                mouseOver: (e) => {
                                    const point = e.target;
                                    $(point.legendItem.label.element).css('fill', '#000000');
                                },
                                mouseOut: (e) => {
                                    const point = e.target;
                                    $(point.legendItem.label.element).css('fill', '#666666');
                                }
                            }
                        }
                    }
                },
                legend: {
                    useHTML: false,
                    itemStyle: {
                        whiteSpace: 'normal',
                        textOverflow: 'none',
                    },
                },
            }
        );
    }
}

export default function () {
    registerPlugin(JobInfoPie)
}
